import { createContext } from 'react';

export const IsFromSearchContext = createContext(false);
